import { combineReducers } from 'redux';

import app from './app';
import listing from './listing';
import rentalApplication from './rentalApplication';
import user from './user';

const root = combineReducers({
  app,
  listing,
  user,
  rentalApplication,
});

export default root;
